import { render, staticRenderFns } from "./AccessInfoSection.vue?vue&type=template&id=2d5df062"
import script from "./AccessInfoSection.vue?vue&type=script&lang=ts"
export * from "./AccessInfoSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports